/**
 * script.js
 * Script de base
 */

jQuery(document).ready(function($) {

    if (typeof Isotope === "function") {

        // RECHERCHE
        // quick search regex
        var qsRegex;
        var buttonFilter;

        // init Isotope
        var itemSelector = '.element-item';
        var layoutMode = 'vertical';
        if ($('#isotope-layout').length != 0) {
            layoutMode = $('#isotope-layout').attr('class');
        }
        if ($('#isotope-not').length != 0) {
            var isotopeNot = $('#isotope-not').attr('class');
        }

        var $grid = $('.grid').isotope({
            itemSelector: itemSelector,
            layoutMode: layoutMode,
            percentPosition: true,
            masonry: {
                columnWidth: itemSelector,
                gutter: 30
            },
            filter: function () {
                //console.log(buttonFilter);
                var $this = $(this);
                var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
                var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
                return searchResult && buttonResult;
            }
        });


        // Quicksearch
        var $quicksearch = $('.quicksearch').keyup(debounce(function () {
            if ($quicksearch.val() !== '') {
                $('.filtres .enleverFiltres.active').removeClass('active');
                $('.filtre-pagination').hide();
                buttonFilter = getComboFilter(filters);
            } else if (!$('.accordion button').hasClass('active')) {
                $('.filtres .enleverFiltres').addClass('active');
                $('.filtre-pagination').show();
                activerPagination();
            }
            qsRegex = new RegExp($quicksearch.val(), 'gi');
            $grid.isotope();
        }, 200));


        // Petit délai pour ne pas filtrer à la milliseconde près (On se laisse un instant pour ecrire avant de filtrer)
        function debounce(fn, threshold) {
            var timeout;
            threshold = threshold || 100;
            return function debounced() {
                clearTimeout(timeout);
                var args = arguments;
                var _this = this;

                function delayed() {
                    fn.apply(_this, args);
                }

                timeout = setTimeout(delayed, threshold);
            };
        }


        // Fonction pour combiner les filtres (https://codepen.io/desandro/pen/btFfG)
        function getComboFilter(filters) {
            var i = 0;
            var comboFilters = [];
            for (var prop in filters) {
                var filterGroup = filters[prop];
                if (!filterGroup.length) {
                    continue;
                }
                if (i === 0) {
                    comboFilters = filterGroup.slice(0);
                } else {
                    var filterSelectors = [];
                    var groupCombo = comboFilters.slice(0); // [ A, B ]
                    for (var k = 0, len3 = filterGroup.length; k < len3; k++) {
                        for (var j = 0, len2 = groupCombo.length; j < len2; j++) {
                            filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
                        }
                    }
                    comboFilters = filterSelectors;
                }
                i++;
            }
            var comboFilter = comboFilters.join(', ');
            return comboFilter;
        }


        // Fonction pour réinitialiser les filtres
        function reinitialiserFiltre() {
            $('.quicksearch').val('');
            qsRegex = new RegExp('', 'gi');
            $('.filtres button').removeClass('active');
            $('.enleverFiltres').addClass('active');
            filters = [];
            activerPagination();
        }

        // Action lors du clique d'un bouton de filtre
        var filters = [];
        var dataFilter = '';
        var filterGroup = '';
        $('.filtres button.filtre').click(function () {
            dataFilter = $(this).attr('data-filter');
            var $buttonGroup = $(this).parents('.accordion');
            filterGroup = $buttonGroup.attr('data-filter-group');

            if (dataFilter === '*') {
                if (!$(this).hasClass('active')) {
                    reinitialiserFiltre();
                }
            } else {

                // Cacher Pagination
                $('.filtre-pagination').hide();

                if ($(this).hasClass('active')) {

                    $(this).removeClass('active');
                    filters[filterGroup] = filters[filterGroup].filter(function (e) {
                        return e !== dataFilter;
                    });
                    if (!$('.accordion button').hasClass('active') && $('.quicksearch').val() === '') {
                        $('.filtres .enleverFiltres').addClass('active');
                        activerPagination();
                        return;
                    }

                } else if ($(this).hasClass('radio')) {

                    $('.filtres .enleverFiltres.active').removeClass('active');
                    $('.filtres .radio.active').removeClass('active');
                    $(this).addClass('active');
                    if (Array.isArray(filters[filterGroup])) {
                        filters[filterGroup] = [];
                        filters[filterGroup].push(dataFilter);
                    } else {
                        filters[filterGroup] = [dataFilter];
                    }

                } else {

                    $('.filtres .enleverFiltres.active').removeClass('active');
                    $(this).addClass('active');
                    if (Array.isArray(filters[filterGroup]))
                        filters[filterGroup].push(dataFilter);
                    else
                        filters[filterGroup] = [dataFilter];

                }

                // combine filters
                buttonFilter = getComboFilter(filters);
                //changeHashFilter(filterGroup, dataFilter);
                $grid.isotope();
            }
        });

        // AUCUN RÉSULTAT ************************************************************************************************************
        $grid.on('arrangeComplete', function (event, filteredItems) {
            var resultCount = filteredItems.length;
            if (resultCount === 0) {
                $('.aucunResultat').show();
            } else {
                $('.aucunResultat').hide();
            }
        });


        // URL hash ************************************************************************************************************
        function getHashFilter() {
            var hash = (location.hash).substring(1);
            var hashFilter = hash.split('&');
            var hashFilterSplit = [];
            var hashFilterData;
            var hashfilterGroup;
            var hashFilterSplitMulti;
            filters = [];
            $('.accordion button').removeClass('active');

            hashFilter.forEach(function (item) {

                hashFilterSplit = item.split('=');
                hashfilterGroup = hashFilterSplit[0];
                hashFilterSplitMulti = hashFilterSplit[1].split('%');

                hashFilterSplitMulti.forEach(function (itemMulti) {
                    hashFilterData = '.' + itemMulti;
                    if (Array.isArray(filters[hashfilterGroup]))
                        filters[hashfilterGroup].push(hashFilterData);
                    else
                        filters[hashfilterGroup] = [hashFilterData];
                    $('.accordion button[data-filter="' + hashFilterData + '"]').addClass('active');
                });

            });

            // combine filters
            buttonFilter = getComboFilter(filters);
            $grid.isotope();
        }

        function changeHashFilter(filterGroupHash, dataFilterHas) {
            window.location.hash = filterGroupHash + '=' + dataFilterHas.replace('.', '');
        }


        // PAGINATION ****************************************************************************************************************
        var itemsPerPage = parseInt($('#posts_per_page').attr('class'));
        var currentNumberPages = 1;
        var $pageSouhaitee = 1;
        var currentPage = 1;
        var currentFilter = '*';
        var filterAtribute = 'data-filter';
        var pageAtribute = 'data-page';
        var pagerClass = 'isotope-pager';
        var $prev = document.getElementsByClassName("pagerNavigation prev");
        var $next = document.getElementsByClassName("pagerNavigation next");
        var $labelPageTotal = document.getElementsByClassName("pageTotal");

        $($prev).on("click", previousPage);
        $($next).on("click", nextPage);

        function goToPage(n) {
            currentPage = n;
            buttonFilter = itemSelector;
            buttonFilter += (currentFilter != '*') ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
            buttonFilter += '[' + pageAtribute + '="' + currentPage + '"]';
            if(isotopeNot != undefined){
                buttonFilter += ':not(.'+isotopeNot+')';
            }
            $grid.isotope();

            //Affiche ou cache les éléments Suivant et Précendent de la pagination
            if (document.querySelector('.next')) {
                //Si il n'y a qu'une seule page
                if (currentPage == 1 && currentNumberPages == 1) {
                    $next[0].style.visibility = 'hidden';
                    $prev[0].style.visibility = 'hidden';
                }//Si on se retrouve à la dernière page
                else if (currentNumberPages == currentPage) {
                    $next[0].style.visibility = "hidden";
                    $prev[0].style.visibility = 'visible';
                }//Si on se retrouve à la première page et que le nombre de page est supérieur à 1
                else if (currentNumberPages > 1 && currentPage == 1) {
                    $prev[0].style.visibility = 'hidden';
                    $next[0].style.visibility = 'visible';
                }
                else {
                    $prev[0].style.visibility = 'visible';
                    $next[0].style.visibility = 'visible';
                }
            }
        }

        //function page précédente
        function previousPage() {
            var newPage;
            var textNewPage;
            newPage = currentPage.valueOf() - 1;
            goToPage(newPage);
            textNewPage = parseInt(newPage);
            $('.pageActuelle').val(textNewPage);
            $('.isotope-pager button.active').removeClass('active');
            $('.isotope-pager button[data-page=' + textNewPage + ']').addClass('active');
        }

        //fonction page suivante
        function nextPage() {
            var newPage;
            var textNewPage;
            newPage = parseInt(currentPage) + 1;
            goToPage(newPage);
            textNewPage = parseInt(newPage);
            $('.pageActuelle').val(textNewPage);
            $('.isotope-pager button.active').removeClass('active');
            $('.isotope-pager button[data-page=' + textNewPage + ']').addClass('active');
        }

        function setPagination() {
            var SettingsPagesOnItems = function () {
                var item = 1;
                var page = 1;
                var selector = itemSelector;
                selector += (currentFilter != '*') ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
                $grid.children(selector).each(function () {
                    if (item > itemsPerPage) {
                        page++;
                        item = 1;
                    }
                    $(this).attr(pageAtribute, page);
                    item++;
                });
                currentNumberPages = page;
            }();
            var CreatePagers = function () {
                var $isotopePager = ($('.' + pagerClass).length == 0) ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);
                var $totalPage = $('<div class="totalPage"></div>');
                $isotopePager.html('');
                $totalPage.html('');
                for (var i = 0; i < currentNumberPages; i++) {
                    var $pager = $('<button class="pager" ' + pageAtribute + '="' + (i + 1) + '"></button>');
                    $pager.html(i + 1);
                    $pager.click(function () {
                        $('.isotope-pager button.active').removeClass('active');
                        $(this).addClass('active');
                        var page = $(this).eq(0).attr(pageAtribute);
                        var theLastPage = currentPage;
                        goToPage(page, theLastPage);
                        //setAttribute(theLastPage);
                    });
                    $pager.appendTo($isotopePager);
                }
                if (document.querySelector('.pageTotal')) {

                    var nbLabel = $labelPageTotal.length;
                    for (i = 0; i < nbLabel; i++) {
                        $labelPageTotal[i].innerHTML = currentNumberPages;
                    }
                    document.querySelector('.pageActuelle').innerHTML = currentPage;
                    $('.pageActuelle').val("1");
                }

                if (currentNumberPages > 1) {
                    $('.filtre-pagination').show();
                    if (currentNumberPages <= 5) {
                        // Pour afficher un type de pagination avec des bouton pour chaque page
                        $('.filtre-pagination-pager').after($isotopePager);
                        $('.isotope-pager button:first-child').addClass('active');
                        $('.filtre-pagination-pager').hide();
                    } else {
                        $('.isotope-pager').hide();
                        $('.filtre-pagination-pager').show();
                    }
                }

            }();
        }

        // Changement de page via la boite de texte
        $(document).on("keyup", ".pageActuelle", (debounce(function () {
            $pageSouhaitee = $('#pageDesktop').val();
            if ($.isNumeric($pageSouhaitee)) {
                goToPage($pageSouhaitee);
            }
        }, 400)));

        function activerPagination() {
            setPagination();
            goToPage(1);
        }


        // MOBILE
        $('#btn-filtres-mobile').click(function () {
            $('.filtres').show();
        });
        $('.filtres').click(function (e) {
            if (e.target.id == "filtres-mobile" || $(e.target).parents("#filtres-mobile").length) {
                if ($(e.target).hasClass('filtres-mobile-x')) {
                    $('.filtres').hide();
                }
            } else {
                $('.filtres').hide();
            }
        });


        // AJAX pour loader les articles par étapes
        var page = 2;
        var style = 'base';
        if($('h1').hasClass('style-media')){style = 'media';}
        function load_posts_by_ajax () {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'html',
                data: {
                    action: 'load_posts_by_ajax',
                    category: (window.location.pathname).replaceAll('/',''),
                    year: $('#filtre-annee').val(),
                    taxonomy_slug: $('.taxonomy-slug').data('array'),
                    page: page,
                    style: style,
                },
                beforeSend: function() {
                    $('.spinner-border').show();
                },
                success: function(res) {
                    page++;
                    if(res === ''){
                        $('.grid-filtres').show();

                        $grid.isotope('reloadItems');
                        reinitialiserFiltre();
                        $grid.isotope('layout');

                        $('.spinner-border').hide();
                        $('.filtre-pagination').css('display','flex');
                        if (window.location.hash) {
                            $('.filtre-pagination').hide();
                            getHashFilter();
                        }
                    } else {
                        $('.grid-filtres').append(res);
                        load_posts_by_ajax ();
                    }
                }
            })
        }
        load_posts_by_ajax();
        /*
        if($('.spinner-border').hasClass('maxPost')){
            load_posts_by_ajax();
        } else {
            activerPagination();
            $('.grid-filtres').show();
            $grid.isotope('reloadItems');
            $grid.isotope('layout');
            reinitialiserFiltre();
            $('.spinner-border').hide();
            $('.filtre-pagination').css('display','flex')
        }
        */

        // AJAX pour changement d'année
        $('#filtre-annee').on('change', function() {
            $('.grid-filtres').html('').hide();
            $('.filtre-pagination').hide();
            page = 1;
            load_posts_by_ajax ();
        });

    }
});